
import { Options, Vue } from "vue-class-component";

@Options({
  data: () => ({
    shoots: [
      {
        name: "Engagement",
        route: "engagement",
        number: 3,
      },
      {
        name: "Wedding",
        route: "wedding",
        number: 440,
      },
      {
        name: "New born",
        route: "olly/new-born",
        number: 1,
      },
      {
        name: "One year old",
        route: "olly/one-year-old",
        number: 18,
      },
    ],
  }),
})
export default class App extends Vue { }
